import type { NavigateFunction } from "react-router-dom";
import type { Authority } from "@safers/api";
import { landingPath } from "@/lib/lastVisit";

const ADMIN_HOME = "/admin/";

function isSafe(url: string | null): url is string {
  return !!url && url.startsWith("/") && !url.startsWith("//");
}

function isAdminUrl(url: string): boolean {
  return url === "/admin" || url.startsWith("/admin/");
}

export interface AfterLogin {
  authority: Authority;
  username: string;
  returnUrl: string | null;
  navigate: NavigateFunction;
}

export function goAfterLogin({ authority, username, returnUrl, navigate }: AfterLogin): void {
  const isAdmin = authority === "ADMIN";
  const wanted = isSafe(returnUrl) ? returnUrl : null;

  const target =
    wanted && (isAdmin || !isAdminUrl(wanted))
      ? wanted
      : isAdmin
        ? ADMIN_HOME
        : landingPath(username);

  if (isAdminUrl(target)) {
    window.location.assign(target);
    return;
  }
  navigate(target, { replace: true });
}
